import React from "react"
import Modal from "react-bootstrap/Modal"
import Icon from "../Utils/Icon"
import { SHELTER_BANNERS } from "./shelter_banners"
import * as styles from "./Styles/ShelterBanner.module.scss"

const PlaceSwitchModal: React.FC<{
  show: boolean
  onClose: Function
}> = ({ show, onClose }) => {
  return (
    <React.Fragment>
      <Modal show={show} onHide={onClose} dialogClassName={styles.modal}>
        <Modal.Header className={styles.title} closeButton>
          <h1>素材ダウンロード</h1>
        </Modal.Header>
        <Modal.Body>
          <p>ホームページなどに自由に貼り付けてご使用ください。</p>
          {SHELTER_BANNERS.map((banner, i) => (
            <div key={i} className={styles.banner}>
              <h2>{`${banner.title}（${banner.size}）`}</h2>
              <img src={banner.src} width={banner.width} />
              <p>
                <a href={banner.path}>
                  <Icon
                    type="feather"
                    name="download"
                    attr={{ width: 16, height: 16 }}
                  />
                  <span>ダウンロード</span>
                </a>
              </p>
            </div>
          ))}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  )
}
export default PlaceSwitchModal
